export function About() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="prose prose-lg max-w-none">
          <h1 className="text-5xl font-bold text-neutral-900 mb-8">About Bizora</h1>
          
          <p className="text-xl text-neutral-600 mb-6">
            Bizora is a modern multi-tenant SaaS platform designed to help local businesses 
            establish and grow their online presence.
          </p>

          <h2 className="text-3xl font-semibold text-neutral-900 mt-12 mb-4">Our Mission</h2>
          <p className="text-neutral-700 mb-6">
            We believe that every local business deserves access to enterprise-level tools 
            without the complexity or cost. Our platform makes it easy for businesses to 
            manage orders, customers, inventory, and more—all from one intuitive interface.
          </p>

          <h2 className="text-3xl font-semibold text-neutral-900 mt-12 mb-4">What We Offer</h2>
          <ul className="text-neutral-700 space-y-2 mb-6">
            <li>• Multi-tenant architecture for complete data isolation</li>
            <li>• Customizable branding per tenant</li>
            <li>• Flexible pricing plans for businesses of all sizes</li>
            <li>• White-label options for resellers</li>
            <li>• Comprehensive API for integrations</li>
          </ul>

          <h2 className="text-3xl font-semibold text-neutral-900 mt-12 mb-4">Contact Us</h2>
          <p className="text-neutral-700">
            Have questions? Reach out to us at <a href="mailto:hello@bizora.com" className="text-primary-600">hello@bizora.com</a>
          </p>
        </div>
      </div>
  )
}

